export default __webpack_public_path__ + "static/media/score-colored.603bb362.svg";